import { ChevronLeft } from 'lucide-react'
import { AppAnalytics } from '../components/app-analytics'
import { DashboardContainer } from '../components/dashboard-container'
import { OperationsTabs } from '../components/operations-tabs'

interface AnalyticsDashboardPageProps {
  slug: string
  appName: string
  onBack: () => void
}

export function AnalyticsDashboardPage({ slug, appName, onBack }: AnalyticsDashboardPageProps) {
  return (
    <div className="flex flex-col h-full overflow-y-auto">
      {/* Page header */}
      <div className="flex items-center gap-3 px-6 py-4 border-b border-border/40 shrink-0">
        <button
          onClick={onBack}
          className="p-1.5 rounded-lg hover:bg-foreground/5 transition-colors text-muted-foreground hover:text-foreground"
          title="Back"
        >
          <ChevronLeft className="w-4 h-4" />
        </button>
        <div>
          <h1 className="text-sm font-semibold text-foreground">{appName}</h1>
          <p className="text-xs text-muted-foreground">Analytics Dashboard</p>
        </div>
      </div>

      {/* Analytics content */}
      <DashboardContainer className="flex-1 space-y-4 py-4">
        <OperationsTabs activeRoute="analytics" />
        <AppAnalytics slug={slug} appName={appName} />
      </DashboardContainer>
    </div>
  )
}
